import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { ActionButtonContainer } from './ShiftDetailsPanel.styles';
import AutoStaffButton from '../../../AutoStaffButton/AutoStaffButton';
import { DRAWER_TYPES } from '../../../../pages/Dashboard/dashboardDrawerConfig';

const DailyShiftsActionButtons = ({ selectedDay, shifts, handleOpenDrawer }) => {
  const handleBottomAddShift = () => {
    // Open AddShiftForm and skip only the date selection step
    handleOpenDrawer(DRAWER_TYPES.ADD_SHIFT, {
      selectedDate: new Date(selectedDay),
      dateFromShiftButton: selectedDay,
    });
  };

  return (
    <ActionButtonContainer>
      <AutoStaffButton fullWidth={true} selectedDay={selectedDay} periodHasShifts={shifts.length > 0} />
      <Button variant="primary" onClick={handleBottomAddShift}>
        Add shift
      </Button>
    </ActionButtonContainer>
  );
};

DailyShiftsActionButtons.propTypes = {
  selectedDay: PropTypes.string.isRequired,
  shifts: PropTypes.array.isRequired,
  handleOpenDrawer: PropTypes.func.isRequired,
};

export default DailyShiftsActionButtons;
